import {Field, FieldProps} from 'formik';
import TextArea from '../../textArea';
import {ChangeEvent} from 'react';

interface TFrmikTextArea
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  name: string;
  label: string;
  description?: string;
  labelClass?: string;
  touched?: boolean;
  customOnChange?: (e: ChangeEvent<HTMLTextAreaElement>) => void;
}
const FormikTextArea = ({
  name,
  label,
  description,
  labelClass,
  touched,
  customOnChange,
  ...props
}: TFrmikTextArea) => {
  return (
    <>
      <Field>
        {({form}: FieldProps) => (
          <>
            <TextArea
              name={name}
              required={props.required}
              label={label}
              className={props.className}
              rows={props?.rows}
              onBlur={form.handleBlur}
              description={description}
              value={form.values[name]}
              errors={form.errors[name]?.toString()}
              touched={Boolean(form.touched[name])}
              placeholder={props.placeholder}
              labelClass={labelClass}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => {
                customOnChange
                  ? customOnChange(e)
                  : form.setFieldValue(name, e.target.value);
              }}
            />
          </>
        )}
      </Field>
    </>
  );
};

export default FormikTextArea;
